<template lang="html">
  <div class="container-fluid p-1 p-lg-5 mt-3">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h6>
              <button class="back-btn" type="button" @click="back()">
                <i class="fas fa-arrow-left"></i>
              </button>
              New Notification
            </h6>
          </div>
          <div class="card-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Title <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="notificationRequest.title"
                />
                <small class="text-danger">{{ validationData.title }}</small>
              </div>
              <div class="form-group">
                <label
                  >Short Description <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="notificationRequest.short_description"
                />
                <small class="text-danger">{{
                  validationData.short_description
                }}</small>
              </div>
              <div class="form-group">
                <label>Body <span class="text-danger">*</span></label>
                <vue-editor v-model="notificationRequest.body" />
                <small class="text-danger">{{ validationData.body }}</small>
              </div>
              <small class="text-danger">{{
                validationData.serverError
              }}</small>
              <button type="submit" class="btn btn-primary float-save">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
    import {
        mapActions
    } from 'vuex'
import env from '../../enviorments'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css';
import {
    VueEditor
} from 'vue2-editor'

export default {
    name: 'notificationCreate',
    metaInfo: {
        title: "Notification",
        titleTemplate: "%s ← New",
    },
    components: {
        Loading,
        VueEditor,
    },
    data() {
        return {
            env,
            isLoading: false,
            fullPage: true,
            image: null,
            users: [],
            weekDays: [{
                    value: "sunday",
                    label: "Sunday"
                },
                {
                    value: "monday",
                    label: "Monday"
                },
                {
                    value: "tuesday",
                    label: "Tuesday"
                },
                {
                    value: "wednesday",
                    label: "Wednesday"
                },
                {
                    value: "thursday",
                    label: "Thursday"
                },
                {
                    value: "friday",
                    label: "Friday"
                },
                {
                    value: "saturday",
                    label: "Saturday"
                }
            ],
            filter: {
                page: "",
            },
            notificationRequest: {
                title: '',
                short_description:"",
                body: '',
                type: 'All',
            },
            validationData: {
                title: "",
                short_description:"",
                body: "",
                serverError: ""

            }
        }
    },
    watch: {
        async $route(to, from) {},
    },
    computed: {},
    methods: {
        ...mapActions({
            notiStoreAllAction: "notiStoreAllAction",
            memberListAction: "memberListAction",
            notiStoreIndividualAction: "notiStoreIndividualAction"
        }),
        readImage(event) {
            this.notificationRequest.image = event.target.files[0];
            this.selectedImage = 1
            //For Show
            const files = event.target.files[0]
            const fileReader = new FileReader()
            fileReader.readAsDataURL(files)
            fileReader.onload = e => {
                this.image = e.target.result
                this.validationRule()
            };
        },
        async onSubmit() {
            this.isLoading = true
            let validation = this.validationRule()
            if (validation == true) {
                this.isLoading = false
                return
            }

            const formData = new FormData();
            formData.append("title", this.notificationRequest.title);
            formData.append("short_description",this.notificationRequest.short_description);
            formData.append("body", this.notificationRequest.body);

            await this.notiStoreAllAction(
                formData
            ).then(res => {
                if (res.success === true) {
                    this.back()
                    this.isLoading = false;
                } else {
					this.isLoading = false;
					this.validationData.serverError = res.message;
					setTimeout(() => {
						this.validationData.serverError = "";
					},3000)
                }
            }).catch(err => this.isLoading = false)
        },
        back() {
            this.$router.replace({
                path: 'notification-list',
                query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    title: '',
                    from_date: '',
                    to_date: '',
                }
            }).catch(() => {})
        },
        validationRule() {
            let isValidation = []
            if (this.notificationRequest.title == "") {
                this.validationData.title = "The title field is required."
                isValidation.push(true)
            } else {
                this.validationData.title = ""
                isValidation.push(false)
            }

            if (this.notificationRequest.short_description == "") {
                this.validationData.short_description = "Short Description field is required."
                isValidation.push(true)
            } else {
                this.validationData.short_description = ""
                isValidation.push(false)
            }


            if (this.notificationRequest.body == "") {
                this.validationData.body = "The body field is required."
                isValidation.push(true)
            } else {
                this.validationData.body = ""
                isValidation.push(false)
            }
            if (isValidation.includes(true)) {
                return true
            } else {
                return false
            }
        },
    },
    async mounted() {}
}
</script>

<style scoped lang="scss">
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  min-height: 56px;
}
.banner-image {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
</style>
